import React from "react";

export const Footer = () => {
  return (
    <footer className="w-full bg-gradient-to-b from-gray-100 to-gray-200 mt-16 md:mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-4 font-elegant">
              Contatti
            </h3>
            <address className="not-italic space-y-3">
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-green-800 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-sm md:text-base text-gray-700 font-elegant">
                  Via Lecco, 18<br />20900 Monza MB
                </p>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-green-800 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a
                  href="tel:+39039388876"
                  className="text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded"
                >
                  +39 039 388876
                </a>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-green-800 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a
                  href="mailto:orologi.strippoli@gmail.com"
                  className="text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded break-all"
                >
                  orologi.strippoli@gmail.com
                </a>
              </div>
            </address>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-4 font-elegant">
              Link Rapidi
            </h3>
            <nav className="space-y-2">
              <a href="/gioielleria" className="block text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded">
                Gioielleria
              </a>
              <a href="/orologeria" className="block text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded">
                Orologeria
              </a>
              <a href="/marchi" className="block text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded">
                I Nostri Marchi
              </a>
              <a href="/chi-siamo" className="block text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded">
                Chi Siamo
              </a>
              <a href="/contattaci" className="block text-sm md:text-base text-gray-700 hover:text-green-800 transition-colors font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 rounded">
                Contattaci
              </a>
            </nav>
          </div>

          {/* About */}
          <div>
            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-4 font-elegant">
              Orologeria Strippoli
            </h3>
            <p className="text-sm md:text-base text-gray-700 font-elegant leading-relaxed">
              Dal dopoguerra, tradizione e passione nell'orologeria e nella gioielleria.
              La nostra esperienza al vostro servizio a Monza.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 my-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <div className="text-sm md:text-base text-gray-600 font-elegant">
            <p className="font-semibold">Strippoli Maurizio & C. Sas</p>
            <p className="text-xs md:text-sm mt-1">P.IVA: 02350930968</p>
          </div>
          <p className="text-xs md:text-sm text-gray-500 font-elegant">
            © {new Date().getFullYear()} Orologeria Strippoli. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};
